import React from 'react';

export interface CanvasRulersProps {
  zoom?: number;
  canvasWidth?: number;
}

export function CanvasRulers({ zoom = 1, canvasWidth = 1200 }: CanvasRulersProps): React.JSX.Element {
  const step = 100;
  const majorTicksCount = Math.ceil(canvasWidth / step) + 2;

  return (
    <div className="relative w-full h-5 bg-card/90 border-b border-border select-none text-[10px] font-mono text-muted-foreground flex overflow-hidden">
      {/* Top Left Corner Box */}
      <div className="w-5 h-5 border-r border-border flex items-center justify-center text-[9px] font-bold text-muted-foreground/60 shrink-0">
        px
      </div>

      {/* Horizontal Ruler Track */}
      <div className="relative flex-1 h-5 overflow-hidden">
        {Array.from({ length: majorTicksCount }).map((_, i) => {
          const pixelPos = i * step * zoom;
          return (
            <div
              key={i}
              className="absolute top-0 bottom-0 flex flex-col justify-between"
              style={{ left: `${pixelPos}px` }}
            >
              <span className="leading-none pl-1 pt-0.5 text-[9px] opacity-70">
                {i * step}
              </span>
              <div className="h-1.5 w-[1px] bg-border" />
            </div>
          );
        })}
      </div>
    </div>
  );
}
